<script>
  import { Highlight } from "svelte-highlight";
  import { javascript } from "svelte-highlight/languages";
  import { atomOneDarkReasonable } from "svelte-highlight/styles";

  export let options = {
    handlers: []
  };

  let code = "";

  function escapeString(escapeString) {
    if (!escapeString) {
      return "undefined";
    }

    return `"${escapeString}"`;
  }
  // Super basic way to generate JavaScript string
  $: {
    code = `// Generated by Finicky Kickstart 
// Save as ~/.finicky.js

module.exports = {
  defaultBrowser: ${escapeString(options.defaultBrowser)},      
`;

    if (!options.checkForUpdate) {
      code += `  options: {
    checkForUpdate: false
  },
`;
    }

    const handlers = options.handlers
      .map(handler => {
        return `    {
      match: ${handler.pattern},
      browser: ${escapeString(handler.browser)}
    }`;
      })
      .join(",\n");

    code += `  handlers: [
${handlers}
  ]
}`;
  }

  function copy() {
    try {
      const copyText = document.querySelector(".copy-code");
      copyText.select();
      document.execCommand("copy");

      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      } else if (document.selection) {
        document.selection.empty();
      }
    } catch (ex) {}
  }  
</script>

<style>
  .copy-code {
    position: absolute;
    right: 100%;
  }
</style>

<svelte:head>
  {@html atomOneDarkReasonable}
</svelte:head>

<section>

  <fieldset>
    <legend>Generated config</legend>
    <button on:click={copy}>Copy to clipboard</button>    
    <Highlight class="code" language={javascript} {code} />
    <textarea class="copy-code">{code}</textarea>
  </fieldset>
</section>
